import PluginMain from "../components/plugin/PluginMain"


function Plugin(){
    return (
        <>
            <PluginMain/>
            
        </>
    )
}

export default Plugin